module.exports = __webpack_public_path__ + "img/logo1.c067f9eb.png";